import { z } from "zod/v4";
import { participantStatusSchema } from "./shared";

export const gameParticipantSchema = z.object({
	id: z.string().uuid(),
	game_id: z.string().uuid(),
	player_id: z.string().uuid(),
	status: participantStatusSchema,
	team: z.union([z.literal(1), z.literal(2)]).nullable(),
	joined_at: z.coerce.date(),
});

export const createGameParticipantSchema = gameParticipantSchema.omit({
	id: true,
	joined_at: true,
});

export const updateGameParticipantSchema = createGameParticipantSchema.partial();
